import { render } from "./AdminArchiveOrders.vue?vue&type=template&id=2d97c3c3"
import script from "./AdminArchiveOrders.vue?vue&type=script&lang=js"
export * from "./AdminArchiveOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__